export default "images/bg2.jpg";